import { Joi } from 'app-webtech-core/schemas';
import { selectors, actions } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { guidePropertiesSelector } from '../selectors/properties';
import { CHANGE_CURRENT_PLAYING, CHANGE_CURRENT_PLAYING_FOR_BI } from './types';
import { clipEnds, episodeEnds, setIsVideoRequested } from '../../player/actions';
import { getChannelIdByIndex } from '../../guide/helpers/getChannelIdByIndex';

const guideChangeCurrentPlayingIndexActionPayloadSchema = Joi.object().keys({
  newIndex: Joi.number().required(),
});

export const guideChangeCurrentPlayingIndexAction = actionCreator(
  CHANGE_CURRENT_PLAYING,
  guideChangeCurrentPlayingIndexActionPayloadSchema,
);

const channelChange4BIAction = actionCreator(CHANGE_CURRENT_PLAYING_FOR_BI);

export const guideChangeCurrentPlayingIndexThunkAction = ({
  newIndex,
  channelId: newChannelID,
  currentlyPlaying,
  doNotTrack = false,
}) => (dispatch, getState) => {
  const state = getState();
  const { list, currentPlayingIndex, previousContentKind } = guidePropertiesSelector(state);

  const payload = { newIndex };

  if (!list.some(({ index }) => index === newIndex)) {
    payload.error = new Error('Invalid index');
  }

  if (currentPlayingIndex === newIndex) {
    return undefined; // clicked on the current channel, no change
  }

  const { clips } = selectors.playbackSession.properties(state);

  dispatch(setIsVideoRequested({ videoRequested: false }));
  // First we need to send actual data then change channel index
  dispatch(guideChangeCurrentPlayingIndexAction(payload));

  const channelID =
    currentlyPlaying === 'vod' ? 'vod' : getChannelIdByIndex(state, currentPlayingIndex);
  if (clips && clips.length > 0) {
    const clipData = {
      channelID,
      episodeID: clips[0].episodeID,
      clipID: clips[0].clipID,
      programTimelineID: clips[0].timelineID,
    };
    if (doNotTrack === false) {
      dispatch(
        channelChange4BIAction({
          newChannelID,
          currentlyPlaying,
          ...clipData,
        }),
      );
    }
    dispatch(actions.podTrackerAds.setAdsPlaying({ isAdsPlaying: false }));
    dispatch(clipEnds({ ...clipData }));
    dispatch(episodeEnds({ ...clipData }));
    if (selectors.guide.properties(state).isAutoPlay) {
      dispatch(actions.guide.setAutoPlay({ isAutoPlay: false }));
    }
    dispatch(
      setIsVideoRequested({
        videoRequested: true,
        id: list[newIndex].id,
      }),
    );
  } else if (previousContentKind === 'viral') {
    const clip = state.viral.content.clips.find(
      (item) => item.slug === state.location.payload.slug,
    );

    // if viral changes to channel automatically
    if (!clip) {
      dispatch(clipEnds({ channelID: 'viral' }));
      dispatch(actions.guide.setAutoPlay({ isAutoPlay: true }));
      if (doNotTrack === false) {
        dispatch(
          channelChange4BIAction({
            newChannelID,
            currentlyPlaying,
            channelID: 'viral',
          }),
        );
      }
      dispatch(actions.podTrackerAds.setAdsPlaying({ isAdsPlaying: false }));
      dispatch(
        setIsVideoRequested({
          videoRequested: true,
          id: list[newIndex].id,
        }),
      );
    } else {
      // if we change viral to channel
      const clipData = {
        channelID: 'viral',
        clipID: clip._id,
      };
      if (doNotTrack === false) {
        dispatch(
          channelChange4BIAction({
            newChannelID,
            currentlyPlaying,
            ...clipData,
          }),
        );
      }
      dispatch(actions.podTrackerAds.setAdsPlaying({ isAdsPlaying: false }));
      dispatch(clipEnds({ ...clipData }));
      dispatch(
        setIsVideoRequested({
          videoRequested: true,
          id: list[newIndex].id,
        }),
      );
    }
  } else if (doNotTrack === false) {
    dispatch(
      channelChange4BIAction({
        newChannelID,
        currentlyPlaying,
        channelID,
      }),
    );
    dispatch(actions.podTrackerAds.setAdsPlaying({ isAdsPlaying: false }));
  }
  return undefined;
};
